import "./main.css";
// @ts-ignore
import "./ts/customElements";
import {Elm} from "./src/Main.elm";
import {getDisplayedGroupsAndVariableIds} from "@qiiro/qiiro-smartdocument";


const groups = window.doc.content.variablesGroups

const generateDocument = async ({documentId, variablesGroups, format}) => {

    const form = new FormData();
    form.set("variablesGroups", JSON.stringify(variablesGroups));
    form.set("format", format);

    const csrfToken = document.querySelector('[name=csrfmiddlewaretoken]').value

    return fetch(`/smartdocs/${documentId}/generate`, {
        method: 'POST',
        body: form,
        headers: {'X-CSRFToken': csrfToken}
    });

};

const downloadFile = async (response, mimeType, filename) => {

    const blob = await response.blob()

    const newBlob = await new Blob([blob], {type: mimeType});
    const data = (window.URL ? URL : webkitURL).createObjectURL(newBlob);

    const link = document.createElement('a');
    link.id = "download-document"
    link.textContent = "download"
    link.href = data;
    link.className = "nav-button right"
    link.download = filename;
    link.click();
}

const {variablesIds, groupsIds} = getDisplayedGroupsAndVariableIds(window.doc, [])

const app = Elm.Main.init({
    node: document.getElementById("root"),

    flags: {
        title: window.doc.title,
        groups,
        displayedVariables: variablesIds,
        displayedGroups: groupsIds
    },
});

if (app.ports) {
    app.ports.callGenerateDocument?.subscribe(async ({variablesGroups, format}) => {
            try {
                const response = await generateDocument({documentId: window.doc.id, variablesGroups, format});

                if (response.ok) {
                    if (response.redirected) {
                        window.location.href = response.url
                    } else {
                        const contentDisposition = response.headers.get('content-disposition')
                        const encodedFileName = contentDisposition.split('filename=').pop()
                        const filename = decodeURI(encodedFileName)
                        await downloadFile(response, response.headers.get('content-type'), filename)
                        app.ports.documentGenerated?.send(null);
                    }
                } else {
                    app.ports.documentGenerationError?.send(null);
                }
            } catch
                (error) {
                console.log(error)
                app.ports.documentGenerationError?.send(null);

            }
        }
    )

    app.ports.changeVariableValue?.subscribe(({variablesGroups, variableId, groupId}) => {
        scrollToEdited(variableId, groupId)
        const {variablesIds, groupsIds} = getDisplayedGroupsAndVariableIds(window.doc, variablesGroups)
        app.ports.changedVariable?.send(variablesIds)
        app.ports.changedGroup?.send(groupsIds)
    })
}

function scrollToEdited(variableId, groupId) {
    const currentlyEditedVariable = document.querySelector(`[data-variable-id="${variableId}"]`)
    const currentlyEditedGroup = document.querySelector(`[data-group-id="${groupId}"]`)
    if (currentlyEditedVariable) {
        const y = currentlyEditedVariable.offsetTop
        const preview = document.querySelector(".document-preview")
        preview.scrollTo(0, (y - 300))
    } else if (currentlyEditedGroup) {
        const y = currentlyEditedGroup.offsetTop
        const preview = document.querySelector(".document-preview")
        preview.scrollTo(0, (y - 300))
    }
}
